import * as React from "react";

const ArrowBackIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 350" {...props}>
		<path d="M212.1 23.18c75.75-.11 3.95-.09 79.7-.2S176.98 137.51 139.45 174.94c-1.93 1.92-1.94 2.82 0 4.75 38.12 38.01 104.16 112.11 142.41 150.38l-69.93 1.14s69.93-1.14 0 0c-50.62-50.6-101.29-101.16-151.82-151.85L212.1 23.18" />
	</svg>
);

export default ArrowBackIcon;
